import { configureStore } from '@reduxjs/toolkit';
import userReducer from './user/userSlice';
import coursesSlice from './courses/coursesSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    courses: coursesSlice,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
